module.exports = __webpack_public_path__ + "static/ueberMich-ad67e4504f15e7ce6d6229b9283817eb.jpg";